import EmptyExaminationResults from './EmptyExaminationResults';

export default EmptyExaminationResults;
